<template>
  <div>
    <base-crud
      crudName="Solicitações de ausencia"
      newText="Nova Solicitação"
      :table="absencesRequestsTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

function format(datetime) {
  return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
}

export default {
  data: function() {
    return {
      absencesRequestsTable: "absencesRequestsTable",
      columns: [
        "id",
        "datetime",
        "user_id",
        "approver_id",
        "status_id",
        "approver_description"
      ],
      tableData: [
        "id",
        "datetime",
        "user_id",
        "approver_id",
        "status_id",
        "approver_description"
      ],
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "datetime",
          "user_id",
          "approver_id",
          "status_id",
          "approver_description"
        ],
        sortable: [
          "id",
          "datetime",
          "user_id",
          "approver_id",
          "status_id",
          "approver_description"
        ],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          datetime: "Data e hora",
          user_id: "Usuário",
          approver_id: "Aprovador",
          status_id: "Status",
          approver_description: "Justificativa do Aprovador"
        },
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "approver", "status"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {
          datetime: function(h, row, index) {
            return format(row.datetime);
          },
          user_id: function(h, row, index) {
            return row.user.name;
          },
          approver_id: function(h, row, index) {
            return row.approver ? row.approver.name : "";
          },
          status_id: function(h, row, index) {
            return row.status.name;
          }
        }
      },
      endPoint: "absencerequests/",
      dataForm: {}
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    query: function(query) {
      let columns = {
        id: "id",
        datetime: "datetime",
        user_id: "user_id",
        approver_id: "approver_id"
      };
      let filters = "";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/AbsenceRequest/Crud.vue